import { render, staticRenderFns } from "./ManualConfirm.vue?vue&type=template&id=9468e1a4&scoped=true&"
import script from "./ManualConfirm.vue?vue&type=script&lang=ts&"
export * from "./ManualConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ManualConfirm.vue?vue&type=style&index=0&id=9468e1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9468e1a4",
  null
  
)

export default component.exports